module.exports = __webpack_public_path__ + "static/media/case1A.340fed4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case1A.mp4
// module id = OHpC
// module chunks = 0